export class UserFilter {
    
    constructor(public userName: string, public password: string) 
    { 
        this.Username = userName;
        this.Password = password;
    }
    
    public Username: string;
    public Password: string;
}

export default UserFilter;